<template>
  <div class="text-theme px-12 py-14 text-16 font-500 bg-theme2">当前项目：{{ userInfo.shop_name }}</div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const userInfo = computed(() => store.state.userInfo);
</script>
